import React from 'react';
import {createRoot} from 'react-dom/client'
import App from './App';
import './Global.scss'
import 'material-icons/iconfont/material-icons.css';

import HttpService from "./services/HttpService";
import UserService from "./services/UserService";

const renderApp = () => {
    const root = createRoot(document.getElementById("root"));
    root.render(<App />);
}

UserService.initKeycloak(renderApp);
HttpService.configure();
